var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoOutline = function SvgInfoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#info_outline_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    stroke: "#21201F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    d: "M7.948 4.519q-.074.178-.074.388 0 .206.072.383t.216.325a1 1 0 0 0 .32.22 1 1 0 0 0 .383.074q.202 0 .375-.074a1 1 0 0 0 .317-.223q.145-.148.216-.325a1 1 0 0 0 .072-.38q0-.21-.072-.388a1 1 0 0 0-.216-.323.954.954 0 0 0-.692-.293.96.96 0 0 0-.696.293 1 1 0 0 0-.22.323M8.31 10.713v-.003l1.23-4.062.003-.014a.045.045 0 0 0-.047-.043l-2.903.09a.044.044 0 0 0-.044.034l-.15.543-.002.016c0 .024.02.045.045.045h.569c.279 0 .392.165.36.422-.019.153-.071.317-.113.466l-.65 1.97c-.13.412-.263.892-.1 1.314.26.669 1.164.705 1.737.483q.309-.12.603-.358l.003-.002q.295-.24.58-.6t.562-.844a.045.045 0 0 0-.011-.06l-.403-.3a.045.045 0 0 0-.062.016 9 9 0 0 1-.341.532q-.165.233-.315.404a1.7 1.7 0 0 1-.265.253q-.107.077-.178.078c-.215 0-.145-.25-.108-.38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "info_outline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgInfoOutline;